// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh3[data-v-a4aafbc2] {\n    margin-top: 10px !important;\n}\n", ""]);
// Exports
module.exports = exports;
